import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL — permanently redirects to keyword-first slug.
export const Route = createFileRoute("/pueblo-web-design")({
  beforeLoad: () => {
    throw redirect({
      to: "/web-design-pueblo-colorado",
      statusCode: 301,
    });
  },
});
